import { helper } from '@ember/component/helper';
import type { GraphLine, GraphGeometry } from '../index.d.ts';
import { generateEnvelopeUpper } from '../utils/graphUtils.ts';
//import { GraphLine, GraphGeometry } from '@ebiz/ember-aditools-graph/..';

export interface EnvelopeUpperSignature {
  Args: {
    Positional: [];
    Named: { line: GraphLine; geometry: GraphGeometry };
  };
  Return: string;
}

const envelopeUpper = helper<EnvelopeUpperSignature>((params, { line, geometry }) => {
  return generateEnvelopeUpper(line, geometry);
});

export default envelopeUpper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'envelope-upper': typeof envelopeUpper;
  }
}
